import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import { withTranslation } from "react-i18next";
import _ from "lodash";
import MarketGrid from "./marketGrid/marketGrid";
import MarketTrades from "./marketTrades/marketTrades";
import UserOrders from "./userOrders/userOrders";
import OrderForm from "./orderForm/orderForm";

class TradingLayout extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "column",
          weight: 75,
          children: [
            {
              type: "row",
              weight: 80,
              children: [
                {
                  type: "tabset",
                  weight: 50,
                  enableMaximize: false,
                  children: [
                    {
                      type: "tab",
                      name: this.props.t("MarketGrid"),
                      enableClose: false,
                      component: "MarketGrid",
                    },
                  ],
                },
              ],
            },
            {
              type: "row",
              weight: 25,
              children: [
                {
                  type: "tabset",
                  weight: 100,
                  enableMaximize: false,
                  children: [
                    {
                      type: "tab",
                      name: this.props.t("MarketTrades"),
                      enableClose: false,
                      component: "MarketTrades",
                    },
                    {
                      type: "tab",
                      name: this.props.t("UserOrders"),
                      enableClose: false,
                      enableScroll: false,
                      component: "UserOrders",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: "column",
          weight: 20,
          children: [
            {
              type: "tabset",
              id: "1",
              weight: 50,
              enableDeleteWhenEmpty: false,
              enableMaximize: false,
              children: [
                {
                  type: "tab",
                  name: this.props.t("OrderForm"),
                  enableClose: false,
                  component: "OrderForm",
                  id: "OrderForm",
                },
              ],
            },
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
    lastGridClick: null,
  };

  handleOrderClicked = (type, data) => {
    this.state.model.doAction(FlexLayout.Actions.selectTab("OrderForm"));
    const lastGridClick = new Date();
    this.setState({ type: type, data: _.cloneDeep(data), lastGridClick: lastGridClick });
  };

  factory = (node) => {
    const componentId = node.getComponent();

    if (componentId === "MarketGrid") {
      const {
        marketControl,
        pickOrder,
        modifyOrder,
        withdrawOrder,
        userAccountId,
        userOrganizationIds,
        tradeOnBehalf,
        tradeAllowed,
      } = this.props;

      return (
        <MarketGrid
          marketControl={marketControl}
          marketInstruments={this.props.marketInstruments}
          marketOrders={this.props.marketOrders}
          organizationOrders={this.props.organizationOrders}
          marketTrades={this.props.marketTrades}
          onOrderClicked={this.handleOrderClicked}
          modifyOrder={modifyOrder}
          withdrawOrder={withdrawOrder}
          pickOrder={pickOrder}
          userAccountId={userAccountId}
          userOrganizationIds={userOrganizationIds}
          tradeOnBehalf={tradeOnBehalf}
          tradeAllowed={tradeAllowed}
        />
      );
    } else if (componentId === "MarketTrades") {
      const { userAccountId, userOrganizationIds, tradeOnBehalf } = this.props;

      return (
        <MarketTrades
          marketTrades={this.props.marketTrades}
          organizationTrades={this.props.organizationTrades}
          userAccountId={userAccountId}
          userOrganizationIds={userOrganizationIds}
          tradeOnBehalf={tradeOnBehalf}
          tradeConfirmationNotification={this.props.tradeConfirmationNotification}
        />
      );
    } else if (componentId === "UserOrders") {
      return (
        <UserOrders
          organizationOrders={this.props.organizationOrders}
          modifyOrder={this.props.modifyOrder}
          withdrawOrder={this.props.withdrawOrder}
        />
      );
    } else if (componentId === "OrderForm") {
      const { type, data, lastGridClick } = this.state;
      const {
        marketControl,
        submitOrder,
        modifyOrder,
        withdrawOrder,
        userAccountId,
        tradeOnBehalf,
        tradeAllowed,
      } = this.props;
      return (
        <OrderForm
          marketControl={marketControl}
          type={type ?? "Bid"}
          data={data ?? {}}
          submitOrder={submitOrder}
          lastGridClick={lastGridClick}
          modifyOrder={modifyOrder}
          withdrawOrder={withdrawOrder}
          userAccountId={userAccountId}
          tradeOnBehalf={tradeOnBehalf}
          tradeAllowed={tradeAllowed}
          marketTrades={this.props.marketTrades}
          marketInstruments={this.props.marketInstruments}
        />
      );
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container">
        <FlexLayout.Layout
          model={this.state.model}
          factory={this.factory}
          onRenderTab={this.handleRenderTab}
        />
      </div>
    );
  };

  handleRenderTab = (node, renderValues) => {
    if (node.getComponent() !== "MarketGrid") {
      return;
    }

    const statusText = this.props.marketsOpen ? "Open" : "Closed";
    const baseContent = renderValues.content;

    renderValues.content = (
      <div
        className="trading-tab-label"
        title={`${renderValues.name} - Markets ${statusText}`}
      >
        <span>{baseContent}</span>
        <span
          aria-hidden="true"
          className={`trading-tab-status trading-tab-status--${
            this.props.marketsOpen ? "open" : "closed"
          }`}
        />
        <span className="visually-hidden">{`Markets ${statusText}`}</span>
      </div>
    );
  };

  render() {
    return this.buildFlexLayout();
  }
}

export default withTranslation(["trading"])(TradingLayout);

